module.exports = __webpack_public_path__ + "static/media/product-16.8b44186f.jpg";